// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-select-container {
  position: relative;
  width: 100%;
  font-family: sans-serif;
  font-size: 14px;
}

.custom-select-trigger {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  background: white;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  display: flex;
  border-color: gray;
  justify-content: space-between;
  align-items: center;
}

.custom-select-options {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  width: 100%;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  margin-top: 4px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.custom-select-option {
  padding: 10px;
  cursor: pointer;
}

.custom-select-option:hover {
  background-color: #f0f0f0; /* Hellgrauer Hover-Hintergrund */
}

.arrow {
  font-size: 12px;
  margin-left: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/custom-select.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB,EAAE,iCAAiC;AAC9D;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB","sourcesContent":[".custom-select-container {\n  position: relative;\n  width: 100%;\n  font-family: sans-serif;\n  font-size: 14px;\n}\n\n.custom-select-trigger {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  background: white;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: left;\n  display: flex;\n  border-color: gray;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.custom-select-options {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  width: 100%;\n  max-height: 200px;\n  overflow-y: auto;\n  background: white;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  margin-top: 4px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.custom-select-option {\n  padding: 10px;\n  cursor: pointer;\n}\n\n.custom-select-option:hover {\n  background-color: #f0f0f0; /* Hellgrauer Hover-Hintergrund */\n}\n\n.arrow {\n  font-size: 12px;\n  margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
